import React from 'react';
import '../../styles/corpoClinico.css';
import NutriRicardo from '../../img/corpoClinico/nutriRicardo.png';

const CorpoClinico: React.FC = () => {
  return (
    <>
      <div className='title_clinic'>
        <h2 className="titulo" id="Corpo_Clinico_Nutri">Corpo Clínico</h2>
      </div>
      <div className="corpo-clinico">
        <div className="zoom_corpo_clinico">
          <div className="corpo-clinico-container">
            <div className="imagem-container">
              <img src={NutriRicardo} alt="Dr. Ricardo" />
            </div>
            <div className="info-container">
              <h3 className="nome">Ricardo Henrique Cortese Magalhães</h3>
              {/*<a href="https://lattes.cnpq.br/9350331289823529"
                target="_blank"
                rel="noopener noreferrer" className="btn-saber-mais">Saiba mais</a>*/}
              <p className="descricao">
                "Nutricionista, especializado em nutrição clínica, hospitalar, comportamental e esportiva.
                Tenho experiência no atendimento individualizado, promovendo mudanças alimentares
                sustentáveis com base em evidências científicas. Experiência em consultórios, hospitais e
                unidades de alimentação e nutrição (UAN), colaborando com equipes multidisciplinares
                para melhorar a saúde e a qualidade de vida dos pacientes. Busca constantemente
                aprimorar os conhecimentos e contribuir para um atendimento nutricional eficiente e
                humanizado."
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="botao-container">
        <br></br>
      </div>
    </>
  );
};

export default CorpoClinico;